// Module
var code = `<div class="ent">
  <div class="ent__input" ng-if="!\$ctrl.onlyTree">
    <input type="text" disabled ng-value="\$ctrl.selectedNode.text" />
    <button type="button" class="btn btn-warning" ng-click="\$ctrl.changeValue()" ng-disabled="\$ctrl.ngDisabled">Change</button>
    <button type="button" class="btn btn-danger" ng-click="\$ctrl.clearSelection()" ng-disabled="\$ctrl.ngDisabled">Clear</button>
  </div>
  <div class="ent__tree-wrapper" ng-show="\$ctrl.treeVisible">
    <label class="ent__tree-search" ng-if="\$ctrl.search">
      <span>Search:</span>
      <input
            type="text"
            ng-model="\$ctrl.searchInput"
            ng-change="\$ctrl.onSearchChanged()"
            ng-model-options="{debounce: 100}"
      />
    </label>
    <div class="ent__tree-element"></div>
  </div>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/technical/ent/ent.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;